import ACIM from "../../Pages/Content/ACIM";
import Business from "../../Pages/Content/Business";
import Clinic from "../../Pages/Content/Clinic/Clinic";
import Conferences from "../../Pages/Content/Conferences/Conferences";
import Courses from "../../Pages/Content/Courses/Courses";
import Grow from "../../Pages/Content/Grow/Grow";
import Happiness from "../../Pages/Content/Happiness/Happiness";
import Marketing from "../../Pages/Content/Marketing/Marketing";
import Mastery from "../../Pages/Content/Mastery";
import Meditations from "../../Pages/Content/Meditations/Meditations";
import Monastery from "../../Pages/Content/Monastery";
import Networking from "../../Pages/Content/Networking/Networking";
import NLP from "../../Pages/Content/NLP/NLP";
import Podcasts from "../../Pages/Content/Podcasts/Podcasts";
import Publishers from "../../Pages/Content/Publishers/Publishers";
import Resources from "../../Pages/Content/Resources/Resources";
import SessionExchange from "../../Pages/Content/SessionExchange/SessionExchange";
import StartPage from "../../Pages/Content/StartPage";
import Support from "../../Pages/Content/Support/Support";
import Training from "../../Pages/Content/Training/Training";
import AmbassadorForm from "../../Pages/Content/AmbassadorForm/AmbassadorForm.jsx";
import NirvaPage from "../../Pages/Content/Nirva";
import PatientPage from "../../Pages/Content/Patient";
import CommunitySupportGroups from "../../Pages/Content/CommunitySupportGroups/CommunitySupportGroups.jsx";
import MessagesPage from "../../Pages/Content/Messages";
import MyProfile from "../../Pages/Content/MyProfile/MyProfile.jsx";
import AdminPractitioners from "../../Pages/Content/AdminPractitioners/AdminPractitioners.jsx";
import BlogModeration from "../../Pages/Content/BlogModeration/BlogModeration.jsx";
import Blog from "../../Pages/Content/Blog";
import NewsletterSubscribers from "../../Pages/Content/NewsletterSubscribers";
export const contentData = {
  home: <StartPage />,
  myProfile: <MyProfile />,
  adminPractitioners: <AdminPractitioners />,
  blogModeration: <BlogModeration />,
  newsletterSubscribers: <NewsletterSubscribers />,
  blog: <Blog />,
  nirva: <NirvaPage />,
  training: <Training />,
  resources: <Resources />,
  clinic: <Clinic />,
  nlp: <NLP />,
  publishers: <Publishers />,
  marketing: <Marketing />,
  business: <Business />,
  networking: <Networking />,
  mastery: <Mastery />,
  miracles: <ACIM />,
  monastery: <Monastery />,
  happiness: <Happiness />,
  exchange: <SessionExchange />,
  support: <Support />,
  ceu: <Courses />,
  conferences: <Conferences />,
  grow: <Grow />,
  meditations: <Meditations />,
  podcasts: <Podcasts />,
  ambassadorForm: <AmbassadorForm />,
  // booking: <BookingPage />,
  communitySupportGroups: <CommunitySupportGroups />,
  patient: <PatientPage />,
  messages: <MessagesPage />,
  // students: <StudentSupport />,
};
